function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 8.5,
  r: 8.25,
  fillOpacity: 0.1,
  stroke: "#2D3C47",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 3.778c.26 0 .472.211.472.472v3.778h3.778a.472.472 0 0 1 0 .944H8.972v3.778a.472.472 0 0 1-.944 0V8.972H4.25a.472.472 0 0 1 0-.944h3.778V4.25c0-.26.211-.472.472-.472z"
}));

var SvgAddWhite = function SvgAddWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/addWhite.2a0e0621.svg";
export { ForwardRef as ReactComponent };